var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    width: 52,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus-svgrepo-com-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #637df4 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m26 52c-14.4 0-26-11.6-26-26 0-14.4 11.6-26 26-26 14.4 0 26 11.6 26 26 0 14.4-11.6 26-26 26zm14.5-26c0-1.1-0.9-2-2-2h-10.5v-10c0-1.1-0.9-2-2-2-1.1 0-2 0.9-2 2v10h-10.5c-1.1 0-2 0.9-2 2 0 1.1 0.9 2 2 2h10.5v11c0 1.1 0.9 2 2 2 1.1 0 2-0.9 2-2v-11h10.5c1.1 0 2-0.9 2-2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.210c5adbad4a9b0125323ca4f797fbd8.svg";
export { ForwardRef as ReactComponent };